import { action } from 'typesafe-actions';

import { GroupingModalTypes, GroupingModalOptionsInterface } from './types';

// Set Open modal
export const setOpenModal = (payload: { openModal: boolean }) =>
  action(GroupingModalTypes.SET_OPEN_MODAL, payload);

// Set Selected Items
export const setSelectedItems = (payload: {
  selectedItems: GroupingModalOptionsInterface[];
}) => action(GroupingModalTypes.SET_SELECTED_ITEMS, payload);
